<template>
  <div class="trazabilidad-buscador container mt-4">
    <h3 class="mb-4">
      <font-awesome-icon icon="project-diagram" class="me-2 text-primary" />
      Trazabilidad Visual
    </h3>

    <div v-if="!codigoInicial">
      <div class="mb-3">
        <label>Buscar Código</label>
        <div class="input-group">
          <input ref="inputBuscar" v-model="codigoBuscar" class="form-control" placeholder="Ej: PB-003-0003-0004"
            @focus="seleccionarTexto" @keyup.enter="buscarTrazabilidad" />
          <button class="btn btn-secondary" @click="pegarYBuscar">Pegar y Buscar</button>
        </div>
      </div>

      <button class="btn btn-primary mb-4" @click="buscarTrazabilidad">Buscar Trazabilidad</button>

    </div>

    <div v-if="loading" class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <TrazabilidadGrafica :nodes="nodes" :edges="edges" :nodoSeleccionado="nodoSeleccionado"
      @seleccionar="nodo => nodoSeleccionado = nodo" />

    <div v-if="toastVisible" class="toast-copiado">Código copiado!</div>
  </div>
</template>

<script>
import axios from "@/axios";
import TrazabilidadGrafica from './TrazabilidadVisual.vue';

export default {
  name: "TrazabilidadBuscador",
  components: { TrazabilidadGrafica },
  props: {
    codigoInicial: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      codigoBuscar: "",
      nodes: [],
      edges: [],
      nodoSeleccionado: null,
      toastVisible: false,
      loading: false
    };
  },
  mounted() {
    if (this.codigoInicial) {
      this.codigoBuscar = this.codigoInicial;
      this.buscarTrazabilidad();
    }
  },
  watch: {
    codigoInicial(nuevo) {
      if (nuevo) {
        this.codigoBuscar = nuevo;
        this.buscarTrazabilidad();
      }
    }
  },
  methods: {
    async buscarTrazabilidad() {
      if (!this.codigoBuscar) return;

      this.loading = true;
      try {
        const res = await axios.get("/api/trazabilidad", {
          params: { codigo: this.codigoBuscar }
        });


        
        const arbol = this.armarArbolOrigenDestino(res.data.origen || [], res.data.destino || []);

        this.nodes = [];
        this.edges = [];

        let idCounter = 0;
        const agregarNodo = (nodo, parentId = null, depth = 0, siblingIndex = 0) => {
          const nodeId = (idCounter++).toString();

          const tipo = nodo.tipo || "Sin Tipo";
          const clase = this.formatearClase(tipo); // Obtener clase según tipo

          this.nodes.push({
            id: nodeId,
            type: "custom",
            position: { x: depth * 250, y: siblingIndex * 180 },
            data: {
              tipo,
              clase,
              codigo: nodo.codigo,
              info: nodo.info || null
            },
            sourcePosition: 'right',
            targetPosition: 'left'
          });

          if (parentId !== null) {
            this.edges.push({
              id: `e${parentId}-${nodeId}`,
              source: parentId,
              target: nodeId,
              type: "default"
            });
          }

          if (nodo.children?.length) {
            nodo.children.forEach((hijo, index) => {
              agregarNodo(hijo, nodeId, depth + 1, index);
            });
          }
        };

        agregarNodo(arbol);
      } catch (err) {
        console.error("Error al buscar trazabilidad:", err);
        alert("No se pudo obtener la trazabilidad. Por favor, verifica el código e inténtalo de nuevo.");
      } finally {
        this.loading = false;
      }
    },
    formatearClase(tipo) {
      const t = tipo.toLowerCase();
      if (t.includes('lote')) return 'nodo lote';
      if (t.includes('biomasa')) return 'nodo biomasa';
      if (t.includes('materia prima')) return 'nodo materia-prima';
      if (t.includes('producto final bulk')) return 'nodo producto-final-bulk';
      if (t.includes('producto envasado')) return 'nodo producto-envasado';
      if (t.includes('no encontrado')) return 'nodo no-encontrado';
      return 'nodo default';
    },
    armarArbolOrigenDestino(origen, destino) {
      if (origen.length === 0) return { tipo: "Sin Origen", codigo: "", children: destino };

      let root = {
        tipo: origen[0].tipo,
        codigo: origen[0].codigo,
        info: origen[0].info || null,
        children: []
      };

      let current = root;

      for (let i = 1; i < origen.length; i++) {
        const newNode = {
          tipo: origen[i].tipo,
          codigo: origen[i].codigo,
          info: origen[i].info || null,
          children: []
        };
        current.children.push(newNode);
        current = newNode;
      }

      current.children = destino;
      return root;
    },
    seleccionarTexto() {
      this.$refs.inputBuscar?.select();
    },
    async pegarYBuscar() {
      try {
        const texto = await navigator.clipboard.readText();
        if (texto) {
          this.codigoBuscar = texto;
          this.buscarTrazabilidad();
        } else {
          alert("El portapapeles está vacío.");
        }
      } catch {
        alert("No se pudo leer el portapapeles.");
      }
    }
  }
};
</script>

<style scoped>
  .trazabilidad-buscador {
    background-color: #f9fbf9; /* $light */
    color: #2a2e35; /* $dark */
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .btn-primary {
    background-color: #4a7d3a; /* $app-primary */
    border-color: #4a7d3a;
    &:hover {
      background-color: #3e6a32; /* darken($app-primary, 10%) */
      border-color: #3e6a32;
    }
  }

  .btn-secondary {
    background-color: #6c5b7b; /* $secondary */
    border-color: #6c5b7b;
    &:hover {
      background-color: #5a4c66; /* darken($secondary, 10%) */
      border-color: #5a4c66;
    }
  }

  .input-group .form-control {
    border-radius: 4px;
    border-color: #2a2e35; /* $dark */
    &:focus {
      border-color: #4a7d3a; /* $app-primary */
      box-shadow: 0 0 0 0.2rem rgba(74, 125, 58, 0.25); /* rgba($app-primary, 0.25) */
    }
  }

  .toast-copiado {
    background-color: #4a7d3a; /* $success */
    color: #f9fbf9; /* $light */
    padding: 10px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
  }

  .spinner-border {
    display: block;
    margin: 20px auto;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
</style>
